/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerSubmitQueryMutationResponse, MultiDocumentAgentControllerSubmitQuery400, MultiDocumentAgentControllerSubmitQuery401, MultiDocumentAgentControllerSubmitQuery403 } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerSubmitQuery";

function getMultiDocumentAgentControllerSubmitQueryUrl() {
  const res = { method: 'POST', url: `/api/v1/multi-document-agent/query` as const }  
  return res
}

/**
 * @description Accepts both flat format (AgentRequestDto) and nested format (ChatRequestDto compatible with /chat/query)
 * @summary Submit a multi-document agent query
 * {@link /api/v1/multi-document-agent/query}
 */
export async function multiDocumentAgentControllerSubmitQuery(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<MultiDocumentAgentControllerSubmitQueryMutationResponse, ResponseErrorConfig<MultiDocumentAgentControllerSubmitQuery400 | MultiDocumentAgentControllerSubmitQuery401 | MultiDocumentAgentControllerSubmitQuery403>, unknown>({ method : "POST", url : getMultiDocumentAgentControllerSubmitQueryUrl().url.toString(), ... requestConfig })  
  return res.data
}